import * as log from 'loglevel';
import {times} from 'lodash';
import 'pixi';
import "phaser";
import {preloadGameAssets} from "./preload/Preload";
import {updateGame} from "./update/Update";
import {createPlayer, resetPlayer} from "./sprites/player/Player";
import {setScaling, scaleGameToWindow} from "./scaling/Scaling";
import {createLevel, levelSprites, levelGroup, resetLevel} from "./level/Level";
import {addInteraction} from "./input/Interaction";
import {render} from "./render/Render";
import {resetCountdownTimer} from './timer/GameTimer';
import {addSounds} from './audio/AudioManager';
import {addStageTimerListeners} from './level/stages/StageManager';
import {createParticles} from './particles/ParticleManager';

export var game: Phaser.Game;

/**
 * bootstrap the game, doing any one-time setup we need
 * @returns {Phaser.Game}
 */
export function bootstrapGame() : Phaser.Game
{
    var gameState: any;

    //  set game options

    gameState =
    {
        preload: () => preloadGameAssets(),
        create: () => createGame(),
        update: () => updateGame()
    };

    //PreloadScene.prototype.fileComplete = function
    //(progress, cacheKey, success, totalLoaded, totalFiles) {    this.progress.text = progress+"%";

    //  create a new Phaser game object

    game = new Phaser.Game(960, 640, Phaser.CANVAS, 'pp-gameplay__canvas', gameState);

    //  return the new game
    
    return game;
}




/**
 * set up the basic game structure
 */
function createGame()
{
    //  set up the physics engine and basic physics props

    game.physics.startSystem(Phaser.Physics.ARCADE);
    game.physics.arcade.gravity.y = 0;

    //  enable this to allow game to play while paused

    //game.stage.disableVisibilityChange = true;

    //  set up audio

    addSounds();

    //  set game scaling properties

    setScaling();

    //  add game interaction

    addInteraction();

    addStageTimerListeners();

    //  create the level

    createLevel();

    //  create particle effects

    createParticles();

    //  create the player sprite

    createPlayer();

    //  pause the game until we're ready to start

    game.paused = true;
}


/**
 * start the game
 */
export function startGame()
{
    setTimeout(() =>
    {
        //  start playing the game

        game.paused = false;

        //  set the game scaling

        scaleGameToWindow();

        //  make the ground cover the width of the screen

        resetLevel();

        //  reset countdown and start the clock

        resetCountdownTimer();
    }, 50);
}


/**
 * reset the game to its starting state
 */
export function resetGame()
{
    //  pause the game

    game.paused = true;

    //  reset all game components

    resetLevel();
    resetPlayer();
}


// WEBPACK FOOTER //
// ./src/ts/game/GameCore.ts